import { getCookie, getLocalStorage, setCookie, setLocalStorage, clearLocalStorage, delCookie } from "@/utils/storage";

export default {
    state: {
        token: getCookie("token") ? getCookie("token") : "",
        userData: getLocalStorage("userData") ? getLocalStorage("userData") : ""
    },
    getters: {
        getToken(state) {
            return state.token;
        },
        getUserData(state) {
            return state.userData;
        }
    },
    mutations: {
        setToken(state, value) {
            state.token = value;
            setCookie("token", value, 2592000);
        },
        setUserData(state, value) {
            state.userData = value;
            setLocalStorage("userData", value);
        },
        delToken(state) {
            state.token = "";
            delCookie("token");
        },
        delUserData(state) {
            state.userData = "";
            clearLocalStorage("userData");
        }
    },
    actions: {
        actionUserData({ getters, commit }) {
            // GET_USER_DATA({}).then((res) => {
            //     if (res.data.code === 200) {
            //         console.log(res.data.data);
            //         commit("setUserData", res.data.data);
            //     }
            // });
        }
    }
};
